import zh_CN from './citys';
import zh_TW from './citys-tw';
import en_US from './citys-en';


export const zh = {
    defaultValue:{ province:'北京',city:'北京',area:'东城区'},
    provinceData:zh_CN
}

export const tw = {
    defaultValue:{ province:'北京',city:'北京',area:'東城區'},
    provinceData:zh_TW
}

export const en = {
    defaultValue:{ province:'Beijing',city:'Beijing',area:'Dongcheng District'},
    provinceData:en_US
}


// WEBPACK FOOTER //
// ./src/provinceData.js